import React from "react";
import styles from "./UIBottomButton.module.scss";
import {useTranslation} from "react-i18next";
// import close from "./images/close.svg";

const sendStatus = {
  Sending: "Sending",
  Created: "Created",
  SendFail: "SendFail",
  Unsend: "Unsend",
  Delete: "Delete",
  Copy: "Copy",
  New: "New",
  Success: "Success",
  Update: "Update",
  Reply: "Reply",
  Forward: "Forward",
  Cancel: "Cancel",
};

const UIBottomButton = (props: any) => {
  const { t } = useTranslation();
  return (
    <div className={styles.groupNoti} >
      <div className={
        props.type.toLowerCase() === sendStatus.Forward.toLowerCase() ? styles.forwardMessage : styles.delMessage
        }
      >
        <div
          className={styles.btnLeft}
          onClick={() => props.handleCancelAction()}
        >
          <p>{t(sendStatus.Cancel)}</p>
        </div>
        <div
          className={styles.btnRight}
          onClick={() => props.handleSubmit(props.type)}
        >
          <p>
            {t(props.type)} ({props.count})
          </p>
        </div>
      </div>
    </div>
  );
};

export default React.memo(UIBottomButton);
